import React from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Button, Col, Row } from "react-bootstrap";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import $ from "jquery";
import { connect } from "react-redux";
import {
  updateTemplatesAction,
  getTemplatesAction
} from "../../actions/EmailTemplatesActions";
import { template } from "lodash";
import * as code from './../../config/Constants';


class Details extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: true,
      textEditorVal: EditorState.createEmpty(),
      newValue: "",
      templates:""
    };
  }

  componentWillMount() {
    this.props.getTemplatesAction(this.props.match.params.id).then(res => {
      if (this.props.templates !== undefined) {
        this.setState({ showLoader: false,templates:this.props.templates });

        var textEditorVal = EditorState.createEmpty();
        let contentBlock = htmlToDraft(this.props.templates.template);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks
          );
          textEditorVal = EditorState.createWithContent(contentState);
        }
        this.setState({
          textEditorVal: textEditorVal,
          newValue: this.props.templates.template
        });
      }
    });
  }
  /** Update template data */
  updateData(data) {
    data.template = this.state.newValue;
    this.props
      .updateTemplatesAction(this.props.match.params.id, data)
      .then(res => {
        if(res.status === code.OK){
        this.setState({templates:res.data,showLoader:false});
        }else{
          this.setState({showLoader:false});

        }
      });
  }

  render() {
    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col>
            <h4 className="title-med mt-0 pt-1">Email Template</h4>
          </Col>
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <div className="container-custom py-3">
              <Formik
                validateOnBlur={true}
                initialValues={this.state.templates}
                enableReinitialize={true}
                validationSchema={Yup.object().shape({
                  subject: Yup.string()
                    .trim()
                    .required("Please enter Subject."),
                  template: Yup.string()
                    .trim()
                    .required("Please enter Template content")
                })}
                onSubmit={values => {
                  if(values.updateButton === "update"){
                    this.setState({showLoader:true});
                  this.updateData(values);
                  }
                }}
              >
                {({
                  values,

                  setFieldValue
                }) => (
                  <Form className="form-sm form-admin">
                    <Row>
                      <Col xs={12}>
                        <div className="form-group">
                          <label className="control-label">
                            Subject<span className="text-danger">*</span>
                          </label>
                          <Field
                            type="text"
                            value={values.subject}
                            className="form-control field_ucfirst"
                            name="subject"
                          ></Field>
                          <ErrorMessage
                            name="subject"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12}>
                        <div className="form-group">
                          <label className="control-label">
                            Template<span className="text-danger">*</span>
                          </label>
                          <Editor
                            wrapperClassName="demo-wrapper wysi-editor"
                            editorClassName="demo-editor"
                            toolbar={{
                              options: ["inline", "list", "link", "blockType"],
                              inline: {
                                inDropdown: false,
                                options: ["bold", "italic"]
                              },
                              list: {
                                inDropdown: true,
                                options: ["unordered", "ordered"]
                              },
                              link: { inDropdown: false, options: ["link"] },
                              blockType: {
                                inDropdown: false,
                                options: ["Blockquote"]
                              }
                            }}
                            name="template"
                            editorState={this.state.textEditorVal}
                            onEditorStateChange={e => {
                              var ediData = draftToHtml(
                                convertToRaw(e.getCurrentContent())
                              );
                              //get editor data and enclose it with output
                              var tempDom = $("<output>").append(
                                $.parseHTML(ediData)
                              );
                              //remove link with mension data
                              $.map(tempDom.find("a.wysiwyg-mention"), function(
                                elem,
                                index
                              ) {
                                let newVal = $(elem).html();
                                elem.replaceWith(newVal);
                              });

                              let finalval = tempDom.html();

                              setFieldValue("template", $(finalval).text());
                              this.setState({
                                textEditorVal: e,
                                newValue: finalval
                              });
                            }}
                            hashtag={{}}
                          />

                          <ErrorMessage
                            name="template"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Button
                          variant="primary"
                          type="submit"
                          size="sm"
                          className="btn-blue w-140"
                          onClick={() => {
                            setFieldValue('updateButton', 'update')
                        }}
                        >
                          Update
                        </Button>
                       
                        <Button
                          variant="primary"
                          type="submit"
                          size="sm"
                          className="btn-blue w-140 btn-outlined ml-3"
                          onClick={() => {
                            this.props.history.push("/emails")

                        }}
                        >
                          Cancel
                        </Button>
                       
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    updatedEmailTemplate: state.reducer.updatedEmailTemplate,
    templates: state.reducer.templates
  };
};

export default connect(mapStateToProps, {
  updateTemplatesAction,
  getTemplatesAction
})(Details);
